<template>
  <div class="part4-wrap">
    <div class="title-wrap">
      <v-title class="title" :text="'我们提供的解决方案'"></v-title>
    </div>
    <div class="main">
      <div class="pic-con">
        <transition name="left" v-for="item in cirData" :key="item.id">
          <template v-if="flag">
            <img class="pic" :class="{'pic-show':item.show}" v-show="item.show" :src="item.url">
          </template>
          <template v-else>
            <div class="pic-none"></div>
          </template>
        </transition>
        <transition name="right" v-for="item in cirData" :key="item.id+'con'">
          <div class="con" :class="{'con-show':item.show}" v-show="item.show">
            <h1>{{item.num}}</h1>
            <h2>{{item.title}}</h2>
            <p>{{item.con}}</p>
          </div>
        </transition>
      </div>
      <circular-sidewards class="cir" :cirData="cirData" @update:timerFlag="timerFlagChange"></circular-sidewards>
    </div>
  </div>
</template>

<script>
  import VTitle from "../plug/VTitle";
  import CircularSidewards from "../plug/CircularSidewards";

  export default {
    components: {
      CircularSidewards,
      VTitle
    },
    name: "part4",
    props: ['flag'],
    data() {
      return {
        timer: null,
        cirData: [
          {
            id: 0,
            show: true,
            url: 'static/img/part4-p1.jpg',
            num: '01',
            title: '新货币接入',
            con: '提供主流及其分支币种接入，提供技术支持及后期维护服务，包括优化算法、修改挖矿机制、解决数字资产交易拥堵、流通不畅等问题以及主流区块链分叉，致力于开发高性能的公有链。'
          },
          {
            id: 1,
            show: false,
            url: 'static/img/part4-p2.jpg',
            num: '02',
            title: '区块链定制功能开发',
            con: '提供共识算法，挖矿机制，智能合约虚拟机移植，区块数据结构定制等区块链定制服务，支持用户完成智能合约编写，实现更加复杂的业务应用场景。'
          },
          {
            id: 2,
            show: false,
            url: 'static/img/part4-p3.jpg',
            num: '03',
            title: '交易所系统解决方案设计与实施',
            con: '针对用户需求，提供单机版及尊享版的服务。提供代码支持及技术文档下载，满足用户完成交易所的搭建及改造，实现定制化功能开发。'
          },
          {
            id: 3,
            show: false,
            url: 'static/img/part4-p4.jpg',
            num: '04',
            title: '其他区块链应用场景及技术支持',
            con: '团队已积累多年区块链底层技术经验，我们致力于以区块链技术为核心，提供灵活的应用 层接口，为用户提供更多创新服务解决方案，推动实现区块链+产业落地。'
          },
          {
            id: 4,
            show: false,
            url: 'static/img/part4-p5.jpg',
            num: '05',
            title: '企业级数字资产管理服务及技术支持',
            con: '支持交易所等企业级钱包开发，分级管理数字资产，提供多重签名等功能，根据用户需求进行资产管理平台的定制化开发。'
          }
        ]
      }
    },
    mounted() {
      this.initPic;
      this.picChange()
    },
    methods: {
      picChange() {
        let that = this;
        clearInterval(that.timer);
        this.timer = setInterval(function () {
          let i = 0;
          while (i < that.cirData.length) {
            if (that.cirData[i].show) {
              if (i === that.cirData.length - 1) {
                that.cirData[i].show = false;
                that.cirData[0].show = true;
              } else {
                that.cirData[i].show = false;
                that.cirData[i + 1].show = true;
              }
              return;
            }
            i++;
          }
        }, 4000);

      },
      timerFlagChange() {
        this.picChange();
      }
    },
    watch: {
      flag: function () {
        let i = 0;
        while (i < this.cirData.length) {
          this.cirData[i].show = false;
          i++;
        }
        this.cirData[0].show = true;
      },
      cirData: function (cirData) {
        console.log(cirData);
        this.picChange();
      }
    }
  }
</script>

<style lang="less" scoped>
  .part4-wrap {
    position: relative;
    height: 100%;
    .title-wrap {
      position: relative;
      height: 20%;
      .title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -100%);
      }
    }
    .main {
      position: relative;
      width: 100%;
      height: 70%;
      .pic-con {
        position: relative;
        width: 100%;
        height: 100%;
        .pic {
          display: block;
          width: 45%;
          position: absolute;
          right: 50%;
          top: 0;
          z-index: 1;
        }
        .pic-none {
          width: 45%;
          position: absolute;
          right: 50%;
          top: 0;
          z-index: 1;
        }
        .pic-show {
          z-index: 10;
        }
        .con {
          position: absolute;
          left: calc(~'50% - 60px');
          top: 10%;
          width: 45%;
          height: 55%;
          background: white;
          box-shadow: 0px 0px 40px rgba(111, 111, 111, 0.04);
          z-index: 20;
          h1 {
            position: absolute;
            /*width: 10%;*/
            /*line-height: 67px;*/
            text-align: center;
            transform: translateX(-50%);
            top: 12px;
            color: #e5e5e5;
            font-size: 6rem;
            letter-spacing: 5px;
          }
          h2 {
            margin-top: 55px;
            margin-left: 110px;
            font-size: 1.8rem;
          }
          p {
            display: block;
            padding-top: 30px;
            margin: 30px 30px 0px 110px;
            color: #999999;
            border-top: 1px solid #e5e5e5;
            font-size: 1.25rem;
          }
        }
        .con-show {
          z-index: 30;
        }
      }
      .cir {
        position: absolute;
        left: calc(~'50% - 70px');
        bottom: 0;
      }
    }
    .left-enter-active, .left-leave-active {
      transition: .5s;
    }
    .left-enter {
      opacity: 0;
      transform: translateX(-653px);
    }
    .right-enter-active, .right-leave-active {
      transition: .5s;
    }
    .right-enter {
      opacity: 0;
      transform: translateX(100%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/part4/Part4.vue